export const SUBSCRIPTION_EXPIRED_STORAGE_KEY = 'subscriptionExpired'
export const RENEWAL_CHECKOUT_STORAGE_KEY = 'renewalCheckout'

export const SUBSCRIPTION_BLOCK_CODES = [
    'SUBSCRIPTION_EXPIRED',
    'TRIAL_EXPIRED',
    'SUBSCRIPTION_INACTIVE',
    'NO_SUBSCRIPTION',
]

export const RENEW_PATH_PREFIXES = [
    '/billing',
    '/renew-subscription',
    '/company-profile',
    '/customers',
]
